<template>
  <div class="new-employee">
    <h4 class="title is-4 has-text-primary">
      Requeridos
    </h4>
    <div class="columns is-multiline">
      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Nombre"
          label-for="privateName"
        >
          <BInput
            id="privateName"
            v-model="privateName"
            placeholder="Rafaeli Camposorio Ruízo"
            icon="account"
            :disabled="loading"
            :loading="loading"
            required
            @input="onInput('name', $event)"
          />
        </BField>
      </div>
      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Email"
          label-for="privateEmail"
        >
          <BInput
            id="privateEmail"
            v-model="privateEmail"
            placeholder="correo@mail.com"
            icon="email"
            type="email"
            :disabled="loading"
            :loading="loading"
            required
            @input="onInput('email', $event)"
          />
        </BField>
      </div>
      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="RFC"
          label-for="privateRfc"
        >
          <BInput
            id="privateRfc"
            v-model="privateRfc"
            placeholder="PAL7202161U0"
            icon="fingerprint"
            :pattern="rfcPattern"
            :disabled="loading"
            :loading="loading"
            required
            @input="onInput('rfc', $event)"
          />
        </BField>
      </div>
      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="CURP"
          label-for="privateCurp"
        >
          <BInput
            id="privateCurp"
            v-model="privateCurp"
            placeholder="CABL840215MDFSRS01"
            icon="human-male"
            :pattern="curpPattern"
            :disabled="loading"
            :loading="loading"
            required
            @input="onInput('curp', $event)"
          />
        </BField>
      </div>

      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Tipo de contrato"
          label-for="privateContractType"
          class="is-fullwidth"
        >
          <BSelect
            id="privateContractType"
            v-model="privateContractType"
            placeholder="Selecciona el tipo de contracto"
            class="is-fullwidth"
            :disabled="loading"
            :loading="loading"
            required
            @input="onInput('contractType', $event)"
          >
            <option
              v-for="option in contractTypeCatalog"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </BSelect>
        </BField>
      </div>

      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Tipo de régimen"
          label-for="privateWorkingDayType"
          class="is-fullwidth"
        >
          <BSelect
            id="privateRegimeType"
            v-model="privateRegimeType"
            placeholder="Selecciona el tipo de contracto"
            class="is-fullwidth"
            :disabled="loading"
            :loading="loading"
            is-fullwidth
            required
            @input="onInput('regimeType', $event)"
          >
            <option
              v-for="option in regimeTypeCatalog"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </BSelect>
        </BField>
      </div>

      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Código postal"
          label-for="zipCode"
        >
          <BInput
            id="zipCode"
            v-model="privateZipCode"
            placeholder=""
            maxlength="5"
            :pattern="zipCodePattern"
            :disabled="loading"
            :loading="loading"
            required
            @input="onInput('zipCode', $event)"
          />
        </BField>
      </div>
    </div>

    <h4 class="title is-4 has-text-primary">
      Opcionales
    </h4>
    <div class="columns is-multiline">
      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Número de Seguro Social"
          label-for="privateSocialSecurityNumber"
        >
          <BInput
            id="privateSocialSecurityNumber"
            v-model="privateSocialSecurityNumber"
            placeholder="123456789"
            icon="hospital"
            :disabled="loading"
            :loading="loading"
            @input="onInput('socialSecurityNumber', $event)"
          />
        </BField>
      </div>

      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Fecha inicio laboral"
          label-for="privateJobRelationshipStart"
        >
          <BDatepicker
            id="privateJobRelationshipStart"
            v-model="privateJobRelationshipStart"
            v-bind="calendarProps"
            :disabled="loading"
            :loading="loading"
            icon="calendar-import"
            @input="onInput('jobRelationshipStart', $event)"
          />
        </BField>
      </div>
      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Sindicalizado"
          label-for="privateUnionized"
        >
          <div class="field has-addons unionized">
            <template v-for="unionized in unionizedCatalog">
              <BRadioButton
                :key="unionized.key"
                v-model="privateUnionized"
                class="unionized-radiobutton"
                name="unionized"
                :disabled="loading"
                :loading="loading"
                :native-value="unionized.value"
                @input="onInput('unionized', $event)"
              >
                <span>{{ unionized.label }}</span>
              </BRadioButton>
            </template>
          </div>
        </BField>
      </div>
      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Tipo de jornada"
          label-for="privateWorkingDayType"
          class="is-fullwidth"
        >
          <BSelect
            id="privateWorkingDayType"
            v-model="privateWorkingDayType"
            placeholder="Selecciona el tipo de contracto"
            class="is-fullwidth"
            :disabled="loading"
            :loading="loading"
            is-fullwidth
            @input="onInput('workingDayType', $event)"
          >
            <option
              v-for="option in workingDayTypeCatalog"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </BSelect>
        </BField>
      </div>

      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Número de empleado"
          label-for="privateEmployedNumber"
        >
          <BInput
            id="privateEmployedNumber"
            v-model="privateEmployedNumber"
            :disabled="loading"
            :loading="loading"
            @input="onInput('employedNumber', $event)"
          />
        </BField>
      </div>
      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Departamento"
          label-for="privateDepartment"
        >
          <BInput
            id="privateDepartment"
            v-model="privateDepartment"
            :disabled="loading"
            :loading="loading"
            @input="onInput('department', $event)"
          />
        </BField>
      </div>

      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Posición"
          label-for="privatePosition"
        >
          <BInput
            id="privatePosition"
            v-model="privatePosition"
            :disabled="loading"
            :loading="loading"
            @input="onInput('position', $event)"
          />
        </BField>
      </div>

      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Nivel de peligro"
          label-for="privateHazardPosition"
        >
          <BSelect
            id="privateHazardPosition"
            v-model="privateHazardPosition"
            placeholder="Selecciona el tipo de contracto"
            class="is-fullwidth"
            :disabled="loading"
            :loading="loading"
            is-fullwidth
            @input="onInput('hazardPosition', $event)"
          >
            <option
              v-for="option in hazardPositionCatalog"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </BSelect>
        </BField>
      </div>

      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Periodicidad del pago"
          label-for="privatePaymentPeriodicity"
        >
          <BSelect
            id="privatePaymentPeriodicity"
            v-model="privatePaymentPeriodicity"
            placeholder="Selecciona el tipo de contracto"
            class="is-fullwidth"
            :disabled="loading"
            :loading="loading"
            is-fullwidth
            @input="onInput('paymentPeriodicity', $event)"
          >
            <option
              v-for="option in paymentPeriodicityCatalog"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </BSelect>
        </BField>
      </div>

      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Banco"
          label-for="privateBank"
        >
          <BSelect
            id="privateBank"
            v-model="privateBank"
            placeholder="Selecciona el tipo de contracto"
            class="is-fullwidth"
            :disabled="loading"
            :loading="loading"
            is-fullwidth
            @input="onInput('bank', $event)"
          >
            <option
              v-for="option in bankCatalog"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </BSelect>
        </BField>
      </div>

      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Número de cuenta"
          label-for="privateBankAccount"
        >
          <BInput
            id="privateBankAccount"
            v-model="privateBankAccount"
            :disabled="loading"
            :loading="loading"
            @input="onInput('bankAccount', $event)"
          />
        </BField>
      </div>

      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Salario Base"
          label-for="privateBaseSalary"
        >
          <BInput
            id="privateBaseSalary"
            v-model="privateBaseSalary"
            :disabled="loading"
            :loading="loading"
            type="number"
            min="0"
            step="0.01"
            @input="onInput('baseSalary', $event)"
          />
        </BField>
      </div>

      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Salario base diario"
          label-for="privateDailyBaseSalary"
        >
          <BInput
            id="privateDailyBaseSalary"
            v-model="privateDailyBaseSalary"
            :disabled="loading"
            :loading="loading"
            type="number"
            min="0"
            step="0.01"
            @input="onInput('dailyBaseSalary', $event)"
          />
        </BField>
      </div>

      <div class="column is-6 is-12-mobile is-4-widescreen">
        <BField
          label="Clave de entidad federativa"
          label-for="privateLocalityKey"
        >
          <BSelect
            id="privateLocalityKey"
            v-model="privateLocalityKey"
            placeholder="Selecciona la entidad federativa"
            class="is-fullwidth"
            :disabled="loading"
            :loading="loading"
            is-fullwidth
            @input="onInput('localityKey', $event)"
          >
            <option
              v-for="option in localityKeyCatalog"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </BSelect>
        </BField>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment-timezone';
import catalogs from '@machete/common-catalogs';
import mappers from '../../../lib/mappers';

const normalizeCatalog = ({ key, value }) => ({ value: key, label: value });

export default {
  name: 'NewEmployee',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      calendarProps: {
        placeholder: 'DD/MM/AAAA',
        monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        dayNames: ['D', 'L', 'Ma', 'Mi', 'J', 'V', 'S'],
        editable: true,
        dateFormatter: date => moment(date).format('DD/MM/YYYY'),
      },
      contractTypeCatalog: catalogs.contractType.map(normalizeCatalog),
      workingDayTypeCatalog: catalogs.workingDayType.map(normalizeCatalog),
      regimeTypeCatalog: catalogs.regimeType.map(normalizeCatalog),
      hazardPositionCatalog: catalogs.hazardPosition.map(normalizeCatalog),
      paymentPeriodicityCatalog: catalogs.paymentPeriodicity.map(normalizeCatalog),
      bankCatalog: catalogs.bank.map(normalizeCatalog),
      localityKeyCatalog: [],
      unionizedCatalog: [
        { value: 'Sí', label: 'Sí' },
        { value: 'No', label: 'No' },
      ],
      privateName: '',
      privateEmail: '',
      privateRfc: '',
      privateCurp: '',
      privateSocialSecurityNumber: '',
      privateJobRelationshipStart: null,
      privateSeniority: '',
      privateContractType: null,
      privateUnionized: null,
      privateWorkingDayType: null,
      privateRegimeType: null,
      privateEmployedNumber: '',
      privateDepartment: '',
      privatePosition: '',
      privateHazardPosition: null,
      privatePaymentPeriodicity: null,
      privateBank: null,
      privateBankAccount: '',
      privateBaseSalary: '',
      privateDailyBaseSalary: '',
      privateLocalityKey: null,
      privateZipCode: '',
      zipCodePattern: '^[0-9]{5}(?:-[0-9]{4})?$',
      curpPattern: '[A-Z][AEIOUX][A-Z]{2}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[MH]([ABCMTZ]S|[BCJMOT]C|[CNPST]L|[GNQ]T|[GQS]R|C[MH]|[MY]N|[DH]G|NE|VZ|DF|SP)[BCDFGHJ-NP-TV-Z]{3}[0-9A-Z][0-9]',
      rfcPattern: '^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$',
    };
  },
  beforeDestroy() {
    this.$store.commit('employee/setValues', {
      name: '',
      email: '',
      rfc: '',
      curp: '',
      socialSecurityNumber: '',
      jobRelationshipStart: '',
      seniority: '',
      contractType: '',
      unionized: '',
      workingDayType: '',
      regimeType: '',
      employedNumber: '',
      department: '',
      position: '',
      hazardPosition: '',
      paymentPeriodicity: '',
      bank: '',
      bankAccount: '',
      baseSalary: '',
      dailyBaseSalary: '',
      localityKey: '',
      zipCode: '',
    });
  },
  async mounted() {
    this.localityKeyCatalog = mappers.stateMapper(await this.requestCatalogSat('state'));
  },
  methods: {
    ...mapActions({
      requestCatalogSat: 'ui/requestCatalogSat',
    }),
    onInput(name, event) {
      this.$store.commit('employee/setValue', { accessor: name, value: event });
    },
  },
};
</script>

<style scoped>
.field.has-addons.unionized .control {
  width: 50%;
}
</style>

<style>
.unionized-radiobutton .b-radio {
  width: 100%;
}
</style>
